module.exports = __webpack_public_path__ + "assets/img/fisfisa-they.8634b715.jpg";